<template>
	<section>
		<div class="bg-color-white">
			<div class="container marketing-section">
				<h3 class="heading-1 text-align-center">Explore all projects in our portfolio</h3>
				<p class="text-align-center"
					>Here are the real estate investments that are powering our investors’ returns.</p
				>
				<BasePlaceHolder :section-count="4" :placehold="loading" class="mt-300-md mt-200-smo">
					<AssetElementContainer
						:asset-elements="assetElements"
						:use-icon-view-options="true"
						:filter-options="filterOptions"
					/>
				</BasePlaceHolder>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { Asset } from 'types/assets';
import AssetElementContainer from '@components/asset-element/asset-element-container.vue';
import { AssetFilterOptions } from 'types/asset-details';
import { getAssets } from '@api/sanity/proxy/assets';

interface Props {
	offeringId: string;
}
const props = defineProps<Props>();

const assetElements = ref<Array<Asset>>([]);
const assetType = ref<Array<string>>([]);
const strategy = ref<Array<string>>([]);

const loading = ref(true);

const filterOptions = computed((): Array<AssetFilterOptions> => {
	return [
		{
			filterClass: 'assetType',
			filterClassLabel: 'Asset type',
			filterType: assetType.value
		},
		{
			filterClass: 'strategy',
			filterClassLabel: 'Strategy',
			filterType: strategy.value
		}
	];
});

function initializeFilterOptions(): void {
	assetElements.value.forEach((element) => {
		if (!assetType.value.includes(element.assetType.name)) {
			assetType.value.push(element.assetType.name);
		}
		if (
			element.realEstateAndPrivateCreditFields?.strategy &&
			!strategy.value.includes(element.realEstateAndPrivateCreditFields.strategy.name)
		) {
			strategy.value.push(element.realEstateAndPrivateCreditFields.strategy.name);
		}
	});
}

async function setup(): Promise<void> {
	const assetsData = await getAssets({ fundId: [props.offeringId], status: 'ACTIVE' });
	assetElements.value = assetsData.results;
	initializeFilterOptions();
	loading.value = false;
}

setup();
</script>
